export default {
  main: "%{title} | FleetYards.net",
  home: "Accueil",
  search: "Résultats de la recherche",
  models: { index: "Vaisseaux" },
  model: "%{name} - %{manufacturer}",
  modelImages: "Images de %{name}",
  modelVideos: "Vidéos de %{name}",
  images: "Images",
  stats: "Statistiques",
  login: "Se connecter",
  signUp: "S'inscrire",
  hangar: {
    index: "Mon Hangar",
    preview: "Aperçu de mon Hangar",
    stats: "Mes statistiques de Hangar",
    import: "Importer",
    public: "Hangar de %{user}",
    wishlist: "Liste de souhait",
    publicWishlist: "%{user} Liste de souhait",
  },
  stations: "Stations",
  shops: "Points de vente",
  starsystems: "Systèmes planétaires",
  starsystem: "Le système %{starsystem}",
  celestialObject: "%{celestialObject} dans le système %{starsystem}",
  station: "%{station} à proximité de %{celestialObject}",
  stationImages: "Images de %{station} à proximité de %{celestialObject}",
  shop: "%{shop} - %{station}",
  requestPassword: "Demander un mot de passe",
  changePassword: "Modifier le mot de passe",
  fleets: {
    add: "Créer une nouvelle flotte",
    preview: "Aperçu de la flotte",
    invites: "Invitations",
    members: "Membres de %{fleet}",
    stats: "Statistiques sur %{fleet}",
    settings: "Paramètres de %{fleet}",
  },
  roadmap: {
    index: "Roadmap",
    ships: "Roadmap vaisseaux",
    changes: "Changement Roadmap",
  },
  settings: {
    index: "Paramètres du profil",
    account: "Compte",
    hangar: "Paramètres de Hangar",
    notifications: "Paramètres de notification",
    security: "Sécurité du Compte",
    twoFactor: {
      enable: "Activer l'authentification à deux étapes",
      disable: "Désactiver l'authentification en deux étapes",
      backupCodes: "Générer des codes de sauvegarde",
    },
  },
  compare: { models: "Comparer les vaisseaux" },
  notFound: "404",
  tools: {
    profitCalculator: "Calculatrice de profits",
    tradeRoutes: "Routes commerciales",
  },
  commodities: "Marchandises",
  impressum: "Mentions légales",
  privacyPolicy: "Politique de confidentialité",
  cookiePolicy: "Politique relative aux cookies",
};
